import React from 'react';
import { Icon } from '../../icon';

export type StandaloneCheckboxProps = {
  readonly value: boolean;
};

const getIconType = () => 'secondary' as const;

export const StandaloneCheckbox = ({ value }: StandaloneCheckboxProps) => {
  const iconType = getIconType();
  return (
    <Icon
      name={value ? 'checkbox-duo' : 'checkbox'}
      type={iconType}
      testID="standaloneCheckbox"
    />
  );
};
